import { ActionIcon, Menu } from "@mantine/core";
import { observer } from "mobx-react";
import { BsCheck2Circle, BsThreeDotsVertical } from "react-icons/bs";
import { MdOutlineRestartAlt } from "react-icons/md";
import { useStores } from "@/hooks/useStores";

interface EpisodeMenuProps {
    episode: Episode;
    podcast: Podcast;
    /** For placing the button, e.g. in the corner of a row */
    className?: string;
}

/** The "more actions" menu on an episode in a list. For now: mark as played / not played. */
export const EpisodeMenu = observer(({ episode, podcast, className }: EpisodeMenuProps) => {
    const { listeningStore } = useStores();
    const played = listeningStore.isPlayed(episode.id);

    return (
        <Menu position="bottom-end" shadow="md" width={220} withinPortal>
            <Menu.Target>
                <ActionIcon
                    aria-label={`Fler åtgärder för ${episode.title}`}
                    className={className}
                    color="gray"
                    radius="xl"
                    size={36}
                    variant="subtle">
                    <BsThreeDotsVertical size={18} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {played ? (
                    <Menu.Item
                        leftSection={<MdOutlineRestartAlt size={16} />}
                        onClick={() => listeningStore.markUnplayed(episode.id)}>
                        Markera som ospelad
                    </Menu.Item>
                ) : (
                    <Menu.Item
                        leftSection={<BsCheck2Circle size={16} />}
                        onClick={() => listeningStore.markPlayed(episode, podcast)}>
                        Markera som spelad
                    </Menu.Item>
                )}
            </Menu.Dropdown>
        </Menu>
    );
});
